export type CountingPages =
    | 'main'
    | 'customers-counting'
    | 'age-gender-recognition'
    | 'groups'
    | 'repartition';
